import NavBar from "./nav-bar";
import Tag from "./Tag";
import styled from "styled-components";

const Header = styled.h1`
  width: 100%;
  margin-bottom: 30px;
`;

export { NavBar, Header, Tag };
